/*
 * File: useApplicationService.ts
 * Project: papa-bear
 * -----
 * Last Modified: 15 Nov 2021 2:13:28 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CompanyModel } from 'models/CompanyModel';
import { ReduxState } from 'redux/store';

/* ****************** Interfaces ****************** */
interface GetLegalEntitiesResponseModel {
  totalCount: number;
  data: CompanyModel[];
}
/* ****************** Variables ****************** */
const maggieCadabbyBaseUrl = process.env.REACT_APP_MAGGIE_CADABBY_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_MAGGIE_CADABBY;

const baseQuery = fetchBaseQuery({
  baseUrl: maggieCadabbyBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as ReduxState).app.accessToken;

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
      headers.set('x-functions-key', functionsKey);
      headers.set('Content-Type', 'application/json');
    }

    return headers;
  }
});

export const legalEntitiesApi = createApi({
  reducerPath: 'legalEntitiesApi',
  baseQuery,
  endpoints: (builder) => ({
    getLegalEntities: builder.query<GetLegalEntitiesResponseModel, undefined>({
      query: () => 'legalEntities'
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetLegalEntitiesQuery, useGetVersionQuery, useGetApiNameQuery } = legalEntitiesApi;
